import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { ConfigService } from '@services/config.service';
import { EnvEnum } from './types/env.enum';

export const defaultNS = 'common';

const isDev = ConfigService.getEnvironment() === EnvEnum.Development;
const commitHash = ConfigService.getCommitHash();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .init({
    lng: 'el',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: isDev
        ? '/locales/{{lng}}/{{ns}}.json'
        : `/locales/{{lng}}/{{ns}}.${commitHash}.json`,
    },
    defaultNS,
    debug: isDev,
    ns: ['common'],
  })
  .then(() => {
    console.log('i18n initialized successfully');
  })
  .catch((error) => {
    console.error('i18n initialization failed', error);
  });

export default i18n;
